import { message, Modal } from "antd";
import React, { ChangeEvent, useState } from "react";
import Input from "../../../../Components/Input";
import Button from "../../../../Components/Button";
import { useCreateCustomersMutation } from "../../../../hooks/CustomerManagement/useCreateCustomersMutation";
import { queryClient } from "../../../../services/queryClient";
import { PhoneInput } from "react-international-phone";

type Props = {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
};

const initialState = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
};

const SearchBox: React.FC<Props> = ({ search, setSearch }) => {
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [payload, setPayload] = useState(initialState);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const handleModalClose = () => {
    setAddCustomerModal(false);
    setPayload(initialState);
  };

  const { mutateAsync, isPending: isLoading } = useCreateCustomersMutation();

  return (
    <div className="flex gap-[10px]">
      <span className="relative">
        <SearchIcon />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="rounded-[10px] border-[1px] border-[#ababab] text-[13px] p-[13px] pl-[35px]"
          placeholder="Search"
        />
      </span>
      <button
        onClick={() => setAddCustomerModal(!addCustomerModal)}
        className="text-white bg-orange py-[13px] height-auto px-[37px] rounded-[10px] text-[14px] flex gap-[10px] items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
        <span>Add Customer</span>
      </button>
      <Modal
        title="New Customer Information"
        open={addCustomerModal}
        onCancel={handleModalClose}
        footer={null}
      >
        <Input
          type="text"
          name="firstName"
          label="First Name"
          value={payload.firstName}
          placeholder="Enter First Name"
          onChange={handleInputChange}
        />
        <Input
          type="text"
          name="lastName"
          label="Last Name"
          value={payload.lastName}
          placeholder="Enter Last Name"
          onChange={handleInputChange}
        />
        <label className="block text-grey text-[16px] manrope capitalize">
          <div className="flex justify-between items-center">Phone Number</div>
        </label>

        <PhoneInput
          defaultCountry="ng"
          className="mt-[13px] mb-3"
          name="phoneNumber"
          value={payload.phoneNumber}
          onChange={(phone) => setPayload({ ...payload, phoneNumber: phone })}
        />
        <Button
          className="text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 bg-brown"
          disabled={
            !payload.firstName || !payload.lastName || !payload.phoneNumber
          }
          isLoading={isLoading}
          label={"Proceed"}
          onClick={() => {
            mutateAsync(payload, {
              onSuccess: (data: any) => {
                message.success(data?.message);
                handleModalClose();
                queryClient.invalidateQueries({
                  queryKey: ["useGetCustomerQuery"],
                });
              },
            });
          }}
        />
      </Modal>
    </div>
  );
};

export default SearchBox;

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-4 absolute top-[18px] left-[15px] text-[#ababab]"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
      />
    </svg>
  );
};
